module.exports = [
    'کاملا موافق',
    'موافق',
    'مخالف',
    'کاملا مخالف',
]